<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><a id="pagev"></a>Contents</p>
<table style="margin-top:3.0em;" width="100%">
<colgroup>
<col width="5%"/>
<col width="95%"/>
</colgroup>
<tbody>
<tr>
<td valign="top"> </td>
<td valign="top"><a href="#/08_foreword#foreword" id="rforeword"><em>Foreword</em></a></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><a href="#/09_acknowledgements#acknowledgements" id="racknowledgements"><em>Acknowledgements</em></a></td>
</tr>
<tr class="spaceUper">
<td valign="top"><a href="#/10_chapter1#ch01" id="rch01"> 1</a></td>
<td valign="top"><a href="#/10_chapter1#ch01">Briefing</a></td>
</tr>
<tr>
<td valign="top"><a href="#/11_chapter2#ch02" id="rch02"> 2</a></td>
<td valign="top"><a href="#/11_chapter2#ch02">The Armies which Passed in the Night</a></td>
</tr>
<tr>
<td valign="top"><span href="#/12_chapter3#ch03" id="rch03" title="Link target outside of Sample"> 3</span></td>
<td valign="top"><span href="#/12_chapter3#ch03" title="Link target outside of Sample">A Long Road to a Barren Hillside</span></td>
</tr>
<tr>
<td valign="top"><span href="#/13_chapter4#ch04" id="rch04" title="Link target outside of Sample"> 4</span></td>
<td valign="top"><span href="#/13_chapter4#ch04" title="Link target outside of Sample">‘Not Fit to Fight In’</span></td>
</tr>
<tr>
<td valign="top"><span href="#/14_chapter5#ch05" id="rch05" title="Link target outside of Sample"> 5</span></td>
<td valign="top"><span href="#/14_chapter5#ch05" title="Link target outside of Sample">U-Go: Overture and Beginners</span></td>
</tr>
<tr>
<td valign="top"><span href="#/15_chapter6#ch06" id="rch06" title="Link target outside of Sample"> 6</span></td>
<td valign="top"><span href="#/15_chapter6#ch06" title="Link target outside of Sample">U-Go: The Siege</span></td>
</tr>
<tr>
<td valign="top"><span href="#/16_chapter7#ch07" id="rch07" title="Link target outside of Sample"> 7</span></td>
<td valign="top"><span href="#/16_chapter7#ch07" title="Link target outside of Sample">U-Go: Relief and Pursuit</span></td>
</tr>
<tr>
<td valign="top"><span href="#/17_chapter8#ch08" id="rch08" title="Link target outside of Sample"> 8</span></td>
<td valign="top"><span href="#/17_chapter8#ch08" title="Link target outside of Sample">Firm Base for a Deadly Thrust</span></td>
</tr>
<tr>
<td valign="top"><span href="#/18_chapter9#ch09" id="rch09" title="Link target outside of Sample"> 9</span></td>
<td valign="top"><span href="#/18_chapter9#ch09" title="Link target outside of Sample">The Master Stroke</span></td>
</tr>
<tr>
<td valign="top"><span href="#/19_chapter10#ch10" id="rch10" title="Link target outside of Sample">10</span></td>
<td valign="top"><span href="#/19_chapter10#ch10" title="Link target outside of Sample">The Battle of the Irrawaddy Bend</span></td>
</tr>
<tr>
<td valign="top"><span href="#/20_chapter11#ch11" id="rch11" title="Link target outside of Sample">11</span></td>
<td valign="top"><span href="#/20_chapter11#ch11" title="Link target outside of Sample">The End in Arakan</span></td>
</tr>
<tr>
<td valign="top"><span href="#/21_chapter12#ch12" id="rch12" title="Link target outside of Sample">12</span></td>
<td valign="top"><span href="#/21_chapter12#ch12" title="Link target outside of Sample">Two Roads to Rangoon</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><span href="#/22_appendixA#appendixA" id="rappendixA" title="Link target outside of Sample"><em>Appendix A</em> –Some Notes on the Imperial Japanese Armoured Corps</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><span href="#/23_appendixB#appendixB" id="rappendixB" title="Link target outside of Sample"><em>Appendix B</em> – Brief Technical Data of Allied Tanks which, Fought in Burma</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><span href="#/24_appendixC#appendixC" id="rappendixC" title="Link target outside of Sample"><em>Appendix C</em> – Table of Approximately Equivalent Ranks, British and Indian Cavalry</span></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><span href="#/25_bibliography#bibliography" id="rbibliography" title="Link target outside of Sample"><em>Bibliography</em></span></td>
</tr>
<tr class="spaceUper">
<td valign="top"> </td>
<td valign="top"><span href="#/26_index#index" id="rindex" title="Link target outside of Sample"><em>Index</em></span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?7b57872e